import { useState } from 'react'
import {
    IMyAccountContext,
    MessageBanner,
    ToastMessage,
} from './useMyAccountContext'
import { ScreenType, screens } from './useScreen'

export const useInitMyAccount = (): IMyAccountContext => {
    /* Main Screen of the right column */
    const [screen, setScreen] = useState<ScreenType>('manage-account')
    /* Determine if left column menu should display on small screen */
    const [isScreenSelected, setScreenSelected] = useState<boolean>(false)

    /* Message Info Banner */
    const [messageBanner, setMessageBanner] = useState<
        MessageBanner | undefined
    >(undefined)

    /* Dismissable Message Toast */
    const [toast, setToast] = useState<ToastMessage>({
        text: '',
        type: 'success',
        show: false,
    })

    // Used as a centralised place to return the page back to the parent
    // page.
    const goBackToParent = (clearMessageBanner: boolean) => {
        const parentScreen = screens[screen].parent

        setMessageBanner(undefined)
        setScreenSelected(true)
        if (screen === 'manage-account') {
            setScreenSelected(false)
        } else if (parentScreen) {
            setScreen(parentScreen)
        }

        if (clearMessageBanner) {
            setMessageBanner(undefined)
        }
    }

    return {
        screen,
        setScreen,
        isScreenSelected,
        setScreenSelected,
        messageBanner,
        setMessageBanner,
        toast,
        setToast,
        goBackToParent,
    }
}
